import './ClientMissions.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getActiveMissions,
  getFundingMethod,
  getCurrentAction,
  getRawActiveMaintenanceMissions,
  getStepModalOpen,
  getStepModalAgreementID
} from 'state/missions/MissionsSelectors';
import { getAccountsById } from 'state/account/AccountSelectors';
import AccountDisplayCard from '../AccountDisplayCard/AccountDisplayCard';
import RegistrationDisplayCard from 'components/shared/RegistrationDisplayCard/RegistrationDisplayCard';
import { LoadingBar } from '@trp-ii-ii-component-library/ii-components';
import ClientMission from './ClientMission';
import OptOutModal from './modals/OptOutModal';
import {
  buildComponentMap,
  filterVisibleMissions,
  getCurrentMission,
  getCurrentMissionName,
  getOverallMissionProgress,
  getTrackerByLikeRegistration,
  HEADER_CONTENT,
  ONBOARDING_MISSIONS
} from './utils/MissionUtils';
import { extractAndFormatOwners } from 'services/Accounts';
import StepModal from '../StepModal/StepModal';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';
import { getIsOnboardingMaintenanceOptOut } from 'state/onboardingMaintenance/OnboardingMaintenanceSelectors';
import { isMobileLayout } from 'state/view/ViewSelectors';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';

const SimpleSideBar = ({ missionName, agreementKey, dismiss }) => (
  <div>
    {dismiss && (
      <OptOutModal missionName={missionName} agreementKey={agreementKey} />
    )}
  </div>
);
const ClientMissions = ({
  accountsById,
  currentStepAction,
  fundingMethod,
  missions,
  maintenanceMissions,
  mobileLayout,
  onboardingMaintenanceOptOut,
  showVisualProgress = true,
  stepModalAgreementID,
  stepModalOpen,
  history,
  requestStatus,
  webViewEnabled
}) => {
  const isLoading = requestStatus && requestStatus['missions'] && requestStatus['missions'] === REQUEST_STATES.requested && !stepModalOpen;
  const isError = requestStatus && requestStatus['missions'] && requestStatus['missions'] === REQUEST_STATES.error;
  const stepModalAccount = accountsById[stepModalAgreementID];
  const rolledUpMissions =
    maintenanceMissions && maintenanceMissions.length
      ? getTrackerByLikeRegistration(stepModalAccount, maintenanceMissions)
      : [];

  //If the tracker call fails do not show the card
  if(isError) {
    return null;
  }

  return (
    <div className="onboarding-container">
      {isLoading ? <div className="client-missions-container-loading">
          <Spinner/>
        </div>
        : <Fragment>
          <StepModal
            id={'step-modal-onboarding'}
            show={stepModalOpen}
            size={!mobileLayout ? 'normal' : 'jumbo'}
            stepKey={currentStepAction}
            componentMap={buildComponentMap(
              stepModalAccount,
              history,
              onboardingMaintenanceOptOut,
              fundingMethod,
              webViewEnabled,
              rolledUpMissions,
              requestStatus
            )}
          />
          {missions.filter(filterVisibleMissions).map((mission, i) => {
            const {agreementKey, dismissCallToActionFlagEligible: dismiss} =
              mission;

            const currentMission = getCurrentMission(mission);
            const currentMissionName = getCurrentMissionName(mission);

            const missionSteps = currentMission?.onboardingMissions;
            const fundingType = currentMission?.fundingType;
            const missionProgress = getOverallMissionProgress(missionSteps);
            const parentAccount = accountsById[agreementKey.agreementID];
            const relatedSweepId = parentAccount
              ? parentAccount['sweepAccountId']
              : null;
            const relatedSweepAccount = relatedSweepId
              ? accountsById[relatedSweepId]
              : null;
            const accountForMission = relatedSweepAccount
              ? relatedSweepAccount
              : parentAccount;

            switch (currentMissionName) {
              case ONBOARDING_MISSIONS.MAINTENANCE:
                //TODO: When the rollup work is done, make sure accountType and owners is a data point for thirty day missions
                return (
                  <Fragment key={i}>
                    <RegistrationDisplayCard
                      accountType={parentAccount.accountType}
                      owners={extractAndFormatOwners(parentAccount)}
                      headerPostText="Next Steps">
                      <div className={'client-missions-container'}>
                        <ClientMission
                          account={parentAccount}
                          fundingType={fundingType}
                          steps={missionSteps}
                        />
                      </div>
                    </RegistrationDisplayCard>
                  </Fragment>
                );
              case ONBOARDING_MISSIONS.FUNDING:
                return (
                  <Fragment key={i}>
                    <AccountDisplayCard
                      accountId={relatedSweepId}
                      headerPreText={HEADER_CONTENT[currentMissionName]}
                      sideBar={
                        <SimpleSideBar
                          missionName={currentMissionName}
                          agreementKey={agreementKey}
                          dismiss={dismiss}
                          steps={missionSteps}
                        />
                      }>
                      {showVisualProgress && (
                        <LoadingBar
                          x={100}
                          y={2}
                          barColor={'#248647'}
                          backgroundColor={'#E9EBED'}
                          loadTime={3}
                          persistVisible={true}
                          benchmarkPercentage={missionProgress * 100}
                        />
                      )}
                      <div className={'client-missions-container'}>
                        <ClientMission
                          account={accountForMission}
                          fundingType={fundingType}
                          steps={missionSteps}
                        />
                      </div>
                    </AccountDisplayCard>
                  </Fragment>
                );
              default:
                return null;
            }
          })}
        </Fragment>
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentStepAction: getCurrentAction(state),
  webViewEnabled: getCustomerWebView(state),
  maintenanceMissions: getRawActiveMaintenanceMissions(state),
  onboardingMaintenanceOptOut: getIsOnboardingMaintenanceOptOut(state),
  fundingMethod: getFundingMethod(state),
  accountsById: getAccountsById(state),
  missions: getActiveMissions(state),
  mobileLayout: isMobileLayout(state),
  stepModalOpen: getStepModalOpen(state),
  stepModalAgreementID: getStepModalAgreementID(state),
  requestStatus: getRequestStatus(state)
});

export default withRouter(connect(mapStateToProps)(ClientMissions));
